module.exports = __webpack_public_path__ + "img/quizz-step-6-3.2f8063ee.jpg";